<template>
    <div>
    
        <Timeline ref="timeline" :items="items" :groups="groups" :options="options" 
        :events="['click','rangechanged','currentTimeTick']" @click="showDetails" 
        @rangechanged="rangechanged" @currentTimeTick="rangechanged" ></Timeline>
    
        <portal-loading :show="showGroup"></portal-loading>
    
        <v-dialog v-model="showInt" width="800" scrollable overlay-color="#fff" overlay-opacity="0.5">
    
            <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
    
                <v-system-bar height="30" color="#fff" class="px-0 mb-3">
    
                    <span></span>
    
                    <v-spacer></v-spacer>
    
                    <v-icon size="32" class="pt-5" @click="showInt = false">mdi-close</v-icon>
    
                </v-system-bar>
    
    
    
                <workorder-info :protocols="protocols" :srs="srs" :workorder="workorder"></workorder-info>
    
            </v-card>
    
        </v-dialog>
    
    
    
        <!-- sign dialog-->
    
        <v-dialog v-model="showSign" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
    
            <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
    
                <v-system-bar height="30" color="#fff" class="px-0 mb-3">
    
                    <span></span>
    
                    <v-spacer></v-spacer>
    
                    <v-icon size="32" class="pt-5" @click="showSign = false">mdi-close</v-icon>
    
                </v-system-bar>
    
    
    
                <sr-info :attachments="attachments" :sr="sr"></sr-info>
    
            </v-card>
    
        </v-dialog>
    
    
    
        <!-- Poi country dialog-->
    
        <v-dialog v-model="showPoiCountry" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
    
            <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
    
                <v-system-bar height="30" color="#fff" class="px-0 mb-3">
    
                    <span></span>
    
                    <v-spacer></v-spacer>
    
                    <v-icon size="32" class="pt-5" @click="showPoiCountry = false">mdi-close</v-icon>
    
                </v-system-bar>
    
    
    
                <poi-country-info :poiCountry="poiCountry"></poi-country-info>
    
            </v-card>
    
        </v-dialog>
        <!-- Captrain Items dialog-->
    
        <v-dialog v-model="showCaptrainItem" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
    
            <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
    
                <v-system-bar height="30" color="#fff" class="px-0 mb-3">
    
                    <span></span>
    
                    <v-spacer></v-spacer>
    
                    <v-icon size="32" class="pt-5" @click="showCaptrainItem = false">mdi-close</v-icon>
    
                </v-system-bar>
    
    
    
                <captrain-item-info :captrainItem="captrainItem"></captrain-item-info>
    
            </v-card>
    
        </v-dialog>
    
    </div>
</template>

<script>
import { Timeline } from "vue-visjs";
import PortalLoading from "./PortalLoading.vue";
import WorkorderInfo from "./WorkorderInfo.vue";
import SrInfo from "./SrInfo.vue";
import { mapActions, mapGetters } from "vuex";
import MaximoService from "@/services/MaximoService";
import {
    formatMagicDate,
    getDefaultPeriod,
    getTimelineViewPeriod,
    //formatTimelinePoiToolTipTime,
} from "@/shared/DateHelper";
//import CascService from "@/services/CascService";
import PoiCountryInfo from "./PoiCountryInfo.vue";
import CaptrainItemInfo from "./CaptrainItemInfo.vue";

export default {

    filters: {},
    props: ["reload", "filter", "items", "buildItem","showExpired"],
    //watch block
    watch: {
        getterCurrentClient: function() {
            this.loadAssets();
        },
        reload(value) {
            this.buildItem(value);
        },

        filter(value) {
            let filterList;
            this.groups = this.assetList;
            //this.buildGroup();
            if (value.length > 0) {
                filterList = this.groups.filter(function(item) {
                    return value.find((filter) => filter == item.id);
                });
                this.groups = filterList;
            }
        },

        showExpired(value){
            let filterList;
            this.groups = this.assetList;
            if(!value){
                filterList = this.groups.filter(elt => (elt.status != "OFF"))
                this.groups = filterList;
            }
            this.groups = this.groups.sort((a,b) => a.id.localeCompare(b.id) )
        }
    },
    //methods block
    methods: {
        ...mapActions("carpet", {
            actionGetAssets: "loadAssets"
        }),

        rangechanged(){
          this.buildItem();
        },
        formatdate(date) {
            return formatMagicDate(date);
        },

        getUserMail() {
            if (this.getterContact.internal) {
                return this.getterContact.mail;
            }
            return "";
        },

        async loadAssets() {
            this.showsr = true;
            this.showkm = true;
            await this.actionGetAssets({
                customer: this.getterCurrentClient,
                start: getDefaultPeriod().start,
                end: getDefaultPeriod().end
            });
            await this.buildGroup();
        },

        async showDetails(event) {
            if (event.item != null) {
                if (event.item.startsWith("SR")) {
                    this.findSrItem(event.item);

                    await MaximoService.getAttachments(this.sr.ldkey)
                        .then((response) => {
                            this.attachments = response.data;
                        })
                        .catch(() => {});
                    this.showSign = true;
                } else if (event.item.startsWith("POI_COUNTRY")) {
                    this.findPoiCountryItem(event.item);
                    this.showPoiCountry = true;
                } else if (event.item.startsWith("VFLI")) {
                    this.findSpecificCaptrainItem(event.item);
                    this.showCaptrainItem = true;
                } else {
                    this.findWoItem(event.item);

                    await MaximoService.getProtocolAndWheel(this.workorder.workorderid)
                        .then((response) => {
                            this.protocols = response.data;
                        })
                        .catch(() => {});
                    await MaximoService.getRelatedRecords(event.item)
                        .then((response) => {
                            this.srs = response.data;
                            //if (this.srs.length == 0) {} else {}
                        })
                        .catch(() => {
                            this.srs = [];
                        });
                    this.showInt = true;
                }
            }
        },

        getWoDate(item, type) {
            if (item.status == "COMP") {
                if (type == "start") {
                    return item.actstart;
                }

                if (type == "end") {
                    return item.actfinish;
                }
            } else if (item.status == "CLOSE") {
                if (type == "start") {
                    return item.actstart;
                }

                if (type == "end") {
                    return item.actfinish;
                }
            } else {
                if (type == "start") {
                    return item.schedstart;
                }

                if (type == "end") {
                    return item.schedfinish;
                }
            }
        },

        //filterByAsset
        filterGroupByAsset() {
            let filterList;
            let filters = this.assets;
            this.groups = this.assetList;
            this.buildGroup();
            if (this.assets.length > 0) {
                filterList = this.groups.filter(function(item) {
                    return filters.find((filter) => filter == item.id);
                });
                this.groups = filterList;
            }
        },

        //findWoitem
        findWoItem(id) {
            this.workorder = this.items.find((e) => e.id == id).workorder;
        },

        //findWoitem
        findSrItem(id) {
            this.sr = this.items.find((e) => e.id == id);
        },

        //find Poi Country Item
        findPoiCountryItem(id) {
            this.poiCountry = this.items.find((e) => e.id == id);
        },

        //find specific Captrain Item
        findSpecificCaptrainItem(id) {
            this.captrainItem = this.items.find((e) => e.id == id);
        },

        //method to create timeline group (assets)
        async buildGroup() {
            this.showGroup = true
            var i;
            this.groups.splice(0, this.groups.length);
            let assets = this.getterAssets.map((a) => a.asset).filter((value, index, array) => array.indexOf(value) === index);

            for (i = 0; i < assets.length; i++) {
                let asset = assets[i];
                let remarks = "";
                let status = this.getterAssets.find((a) => a.asset == asset && a.leasedState == 'leased')
                this.groups.push({
                    id: asset,
                    content: asset,
                    status: status == undefined ? 'OFF' : status.assetStatus,
                    //location: asset.location,
                    remarks: remarks,
                    subgroupOrder: function(a, b) {
                        return a.subgroupOrder - b.subgroupOrder;
                    },
                    subgroupStack: {
                        sign: true,
                        int: true,
                        road: false,
                        captrain: false,
                    },
                });
            }
            this.assetList = this.groups;
            this.showGroup = false
        },
    },
    //Computed block
    computed: {
        ...mapGetters("auth", {
            getterCurrentClient: "getCurrentClient",
            getterContact: "getUserContact",
        }),

        ...mapGetters("carpet", {
            getterAssets: "getAssets",
            getterWos: "getWos",
            getterSrs: "getSrs",
            getterAgreements: "getAgreements",
        }),
    },
    //mounted block
    mounted() {
      this.buildItem();
        this.loadAssets();
        
    },
    //components block
    components: {
        Timeline,
        PortalLoading,
        WorkorderInfo,
        SrInfo,
        PoiCountryInfo,
        CaptrainItemInfo,
    },
    //data block
    data() {
        return {
            woloading: false,
            srloading: false,
            protocols: [],
            attachments: [],
            showsr: false,
            showkm: false,
            showGroup: true,
            workorder: {},
            sr: {},
            showSign: false,
            showInt: false,
            serialList: [],
            statusList: [],
            srs: [],
            serials: [],
            assets: [],
            assetList: [],
            groups: [{}],
            specs: [],
            serviceRequest: {
                title: "",
                description: "",
                description_longdescription: "",
                pluspcustomer: "",
                assetnum: "",
                location: "",
                reportedpriority: "",
                reportedby: "",
            },
            options: {
                stack: true,
                verticalScroll: true,
                zoomKey: "ctrlKey",
                maxHeight: 500,
                showCurrentTime: true,
                stackSubgroups: true,
                start: getTimelineViewPeriod().start,
                end: getTimelineViewPeriod().end,
                min: getDefaultPeriod().start, // lower limit of visible range
                max: getDefaultPeriod().end,
                zoomMin: 1000 * 60 * 60 * 24 * 3,
                orientation: "top",
                locale: "fr",
                groupTemplate: function(group) {
                    var container = document.createElement("div");

                    var status = document.createElement("img");
                    status.src = "../" + group.status + ".png";
                    container.insertAdjacentElement("afterbegin", status);
                    var label = document.createElement("a");
                    if (group?.status != 'OFF') {
                        label.href = document.location.origin + "/infoloc/" + group.content;
                    }
                    label.innerHTML = group.content + " ";
                    status.insertAdjacentElement("afterend", label);
                    return container;
                },
            },
            poiTooltips: [],
            showPoiCountry: false,
            poiCountry: {},
            captrainItem: {},
            showCaptrainItem: false,
        };
    },
};
</script>

<style scoped>
.dp {
    color: #00475a;
    font-weight: bolder;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    color: #fff;
    font-size: 16px;
}

.mtitle {
    color: #00475a;
    margin-bottom: 5px;
    margin-top: 20px;
    font-size: 16px;
}

.value {
    font-size: 16px;
}
</style>
